import React from 'react';
import ArrowDownBlack from '../assets/images/ArrowDownBlack.svg';
import Select from 'react-select';

const colourStyles = {
  control: (styles, { isFocused, disabled }) => ({
    ...styles,
    backgroundColor: 'white',
    padding: '12px',
    textTransform: 'uppercase',
    cursor: 'pointer',
    border: isFocused ? '1px solid black' : '1px solid #00000029',
    boxShadow: isFocused ? '0 3px 6px #00000029' : 'none',
    borderRadius: 0,
    height: '45px',
    '>div': {
      padding: 0
    },

    img: {
      opacity: isFocused ? '1' : '0.5'
    },

    ':hover': {
      border: '1px solid black',
      boxShadow: '0 3px 6px #00000029',
      img: {
        opacity: '1'
      }
    }
  }),
  menuList: (styles) => ({
    ...styles
  }),
  option: (styles, { isFocused, isSelected }) => ({
    ...styles,
    background: isFocused ? 'rgba(0,0,0,0.6)' : isSelected ? 'black' : 'white',
    color: isFocused ? 'white' : isSelected ? 'white' : 'black',
    zIndex: 1,
    textTransform: 'uppercase'
  }),
  menu: (base) => ({
    ...base,
    zIndex: 100
  })
};

const DropdownIndicator = () => {
  return <img src={ArrowDownBlack} alt="arrow down" />;
};

const SelectInput = ({
  label,
  options,
  value,
  onChange,
  placeholder,
  defaultValue,
  parentClass,
  autoFocus,
  onBlur,
  error,
  errorClassName,
  disabled
}) => {
  return (
    <div className={`${parentClass}`}>
      {label && (
        <label htmlFor={label} className="mb-1 block">
          {label}
        </label>
      )}
      <Select
        isDisabled={disabled}
        defaultValue={defaultValue}
        autoFocus={autoFocus}
        isSearchable={false}
        styles={colourStyles}
        classNamePrefix="dropdown"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        onBlur={onBlur}
        options={options}
        components={{
          IndicatorSeparator: () => null,
          DropdownIndicator
        }}
      />
      {error && <span className={`text-red text-sm ${errorClassName}`}>{error.message}</span>}
    </div>
  );
};

export default SelectInput;
